import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';

import {
  postGrandFinancialPlan,
  updateGrandFinancialPlan,
} from '../../data/store/account/accountActions';

import { Button, Col, Form, Input, Layout, Row } from 'antd';
import { CustomTextarea } from '../../components/CustomTextfield/CustomTextfield';
import CustomInputNumber from '../../components/CustomInputNumber/CustomInputNumber';

import { ReactComponent as Cross } from '../../assets/cross-btn-icon.svg';
import { ReactComponent as Delete } from '../../assets/delete-black-icon.svg';
// import { ReactComponent as Edit } from '../../assets/edit-icon.svg';
import ModalDeletePlan from './ModalDeletePlan';

const { Header } = Layout;

const FinancialPlanInfo = ({ financialPlan, finplanId, t, userId }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { url } = useRouteMatch();
  const history = useHistory();

  const [needSaveInfo, setNeedSaveInfo] = useState(false);
  const [modalDeleteVisible, setModalDeleteVisible] = useState(null);

  const hasChanges = (allValues) => {
    const { name, description, year, amount } = allValues;
    const isValid = name && year && amount;
    const isChange = financialPlan
      ? !(
          name === financialPlan?.name &&
          description === financialPlan?.description &&
          year === financialPlan?.year &&
          amount === financialPlan?.amount
        )
      : true;
    return isValid && isChange;
  };

  useEffect(() => {
    if (financialPlan) {
      form.setFieldsValue(financialPlan);
    }
  }, [financialPlan]);

  useEffect(() => {
    console.log('needSaveInfo', needSaveInfo);
  }, [needSaveInfo]);

  const handleChange = (_, allValues) => {
    setNeedSaveInfo(hasChanges(allValues));
  };

  const handleResetEdit = () => {
    form.resetFields();
    history.push(`${url}/stages`);
  };

  const handleSubmit = () => {
    form.submit();
  };

  const onCreateFinPlan = () => {
    const data = form.getFieldsValue(true);

    if (!data?.id) {
      dispatch(postGrandFinancialPlan({ accountId: userId, data, history }));
    } else {
      dispatch(updateGrandFinancialPlan({ accountId: userId, data, history }));
    }
  };

  const handleDeleteModal = () => {
    setModalDeleteVisible(finplanId);
  };

  return (
    <div className="finplan" style={{ position: 'relative' }}>
      <Header className="headerStyle">
        <Row className="overview-tabs-wrapper">
          <Col className="tabs-tab-wrapper" span={18}>
            <h1 className="suggested-portfolios-title header-plan">
              {t('FINANCIAL_PLAN')}
            </h1>
            <span className="header-plan-name">
              {finplanId === 'new' ? t('NEW') : financialPlan?.name}
            </span>
          </Col>
          <Col span={6} className="action-btn-wrapper" style={{paddingRight: '48px'}}>
            {financialPlan && (
              <Button
                type="text"
                className="portfolio-cancel-btn"
                style={{ marginRight: '8px' }}
                icon={<Cross />}
                iconPosition="end"
                onClick={handleResetEdit}
              >
                {t('CANCEL')}
              </Button>
            )}
            <Button
              type="default"
              className="portfolio-save-btn"
              onClick={handleSubmit}
              disabled={!needSaveInfo}
            >
              {t('SAVE')}
            </Button>
          </Col>
        </Row>
      </Header>
      <div className="financial-plan-aside-wraper">
        <div className="financial-plan-aside">
          <div className="financial-plan-title-wrapper">
            <Row
              className="financial-plan-title-wrapper"
              justify={'space-between'}
            >
              <Col span={12}>
                <h3 className="finplan-form-headers">{t('FINANCIAL_PLAN')}</h3>
              </Col>
              <Col
                span={12}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '8px',
                }}
              >
                <Button
                  type="text"
                  className="round-button"
                  icon={<Delete />}
                  onClick={handleDeleteModal}
                />
                {/* <Button
                  type="text"
                  className="round-button"
                  icon={<Edit />}
                  // onClick={handleExportPortfolio}
                /> */}
              </Col>
            </Row>
          </div>
          <Form
            form={form}
            name="finplan-form"
            layout="vertical"
            onValuesChange={handleChange}
            onFinish={onCreateFinPlan}
          >
            <Form.Item
              name="name"
              className="custom-required full-width"
              required={false}
              rules={[
                {
                  required: true,
                  message: t('PLEASE_ENTER_A_NAME'),
                },
              ]}
            >
              <Input
                placeholder={t('NAME')}
                className="custom-input full-width finplan-input"
              />
            </Form.Item>
            <p className="finplan-form-title">{t('DESCRIPTION')}:</p>
            <Form.Item
              name="description"
              className="custom-required full-width"
              required={false}
            >
              <CustomTextarea
                width={'100%'}
                className="finplan-textarea"
                rows={4}
                placeholder={t('YOUR_TEXT')}
                maxLength={200}
              />
            </Form.Item>
            <p className="finplan-form-title">{t('TRANSFER_YEAR')}:</p>
            <Form.Item
              name="year"
              className="custom-required full-width"
              required={false}
              rules={[
                {
                  required: true,
                  message: t('PLEASE_ENTER_A_YEAR'),
                },
              ]}
            >
              <CustomInputNumber
                placeholder={t('2030')}
                className="custom-input full-width finplan-input year"
              />
            </Form.Item>
            <p className="finplan-form-title">{t('TRANSFER_AMOUNT')}:</p>
            <Form.Item
              name="amount"
              className="custom-required full-width"
              required={false}
              rules={[
                {
                  required: true,
                  message: t('PLEASE_ENTER_AMOUNT'),
                },
              ]}
            >
              <CustomInputNumber
                min={0}
                placeholder={t('00,00 kr')}
                className="custom-inputnumber full-width finplan-input"
                formatter={(value) =>
                  value
                    ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'
                    : ''
                }
                parser={(value) =>
                  value
                    ? value.replace(/\s?kr\s?|( )/g, '').replace(/\s/g, '')
                    : ''
                }
                controls={false}
              />
            </Form.Item>
          </Form>
        </div>
      </div>
      <ModalDeletePlan
        userId={userId}
        modalDeletePlan={modalDeleteVisible}
        setModalDeletePlan={setModalDeleteVisible}
      />
    </div>
  );
};

export default FinancialPlanInfo;

FinancialPlanInfo.propTypes = {
  t: PropTypes.func,
  financialPlan: PropTypes.object,
  finplanId: PropTypes.string,
  userId: PropTypes.string,
};
